module.exports = __webpack_public_path__ + "img/clock.f078af35.svg";